import { MdDialogRef } from '@angular/material';
import { Component } from '@angular/core';

@Component({
  selector: 'info-dialog',
  template: `
        <p>{{ title }}</p>
        <p>{{ message }}</p>
        <button type="button" md-raised-button color="primary"
            (click)="dialogRef.close(true)">OK</button>
    `,
})
export class InfoDialog {

  public title: string;
  public message: string;

  constructor(public dialogRef: MdDialogRef<InfoDialog>) {

  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/component/dialog/info-dialog.component.ts